import React from "react";
import "./index.scss";
import { Title, Container, DurationInput, Select } from "components/Form";
import { IoMdClose } from "react-icons/io"
import useT from "utils/hooks/useT"

export default function AssetSetup({
  index,
  assetRequirement,
  setAssetRequirement,
  removeAssetRequirement,
  assets,
  isDefinition,
  disabled,
  sortedCollection
}) {
  const { assetSetuptime, assetPerSampleDuration, assetOffset, allowedAssetIds, assetId } = assetRequirement;
  const { t } = useT("common")

  const assetsArray = Object.values(assets);
  const sortedAssets = assetsArray.sort((a, b) => a.name.localeCompare(b.name));
  const assetName = index === 0 ? t("primary") : index + 1;

  // Find the allowed asset ids in sortedAssets
  const allowedAssetIdsArray = allowedAssetIds.map((id) => sortedCollection.find((asset) => asset.id === id))

  return (
    <div className="container-compartment">
      <p>{t("instrumentSetup", { name: assetName })}</p>
      <Container>
        {isDefinition && !disabled && (<IoMdClose className="remove-asset-btn" title={t("removeInstrument")} onClick={() => removeAssetRequirement(index)} />)}
        <Title>{t("instrumentSetuptime")}</Title>
        <DurationInput
          value={assetSetuptime}
          onChange={(e) => setAssetRequirement('assetSetuptime', e)}
          required
          disabled={disabled}
        />
      </Container>
      <Container>
        <Title>{t("instrumentPerSampleDuration")}</Title>
        <DurationInput
          required
          withSeconds
          value={assetPerSampleDuration}
          onChange={(e) => setAssetRequirement('assetPerSampleDuration', e)}
          disabled={disabled}
        />
      </Container>
      <Container>
        <Title>{t("instrumentOffset")}</Title>
        <DurationInput
          value={assetOffset}
          onChange={(e) => setAssetRequirement('assetOffset', e)}
          required
          disabled={disabled}
        />
      </Container>
      {index > 0 && !isDefinition && (
        <Container>
          <Title>{t("usedInstrument")}</Title>
          <Select
            name={t("usedInstrument")}
            collection={allowedAssetIdsArray}
            value={assetId}
            onChange={(e) => {setAssetRequirement('assetId', e[0])}}
            menuPosition="fixed"
            isMulti={false}
            disabled={disabled}
          />
        </Container>
      )}
      {isDefinition && (
        <Container>
          <Title>{t("allowedInstruments")}</Title>
          <Select
            name={t("allowedInstruments")}
            collection={sortedAssets}
            value={allowedAssetIds}
            onChange={(e) => setAssetRequirement('allowedAssetIds', e)}
            menuPosition="fixed"
            disabled={disabled}
          />
        </Container>
      )}
    </div>
  );
}
